module.exports = __webpack_public_path__ + "img/cardGallery3.jpg?f23c12d9436304c9361dc859fce8cfa3";